import { getBaseName, getEnv } from 'config/Env';

export function Logo() {
    const metaTitle = getEnv('META_TITLE', 'DocRevolution');
    const logo = getEnv('LOGO_FILE', 'docrevolution.png');
    const baseName = getBaseName();

    return <img src={`${baseName}images/logo/${logo}`} className="logo img-fluid" alt={metaTitle} />;
}
